import {Button, Card, CardBody, CardFooter, Input, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import Dict from "../../helper/dict";
import SelectInput from "../system/select";
import {bankPayment} from "../../services/payment/payment";
import {getBankAccounts} from "../../services/bank_account/bank_account";
import {BsClockHistory, BsDatabaseDown, BsDatabaseUp, BsWallet2} from "react-icons/bs";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import WalletReservation from "../system/walletReservation";
import {getUserWallet, submitWalletWithdrawal} from "../../services/wallet/wallet";
import {Toaster} from "../../helper/Toaster";
import {WalletChangesGrid} from "./grid";
import axios from "axios";
import {getBaseUrl} from "../../config"


export function Wallet() {

  const [wallet, setWallet] = useState({});
  const [walletBalance, setWalletBalance] = useState(0);
  const [walletReservationBalance, setWalletReservationBalance] = useState(0);
  const [walletWithdrawalBalance, setWalletWithdrawalBalance] = useState(0);

  const [roleId, setRoleId] = useState(3)

  const [walletChanges, setWalletChanges] = useState([])

  const [depositValue, setDepositValue] = useState(null);
  const [withdrawalValue, setWithdrawalValue] = useState(null);
  const [withdrawalAccountId, setWithdrawalAccountId] = useState(null)

  const [reserves, setReserves] = useState([]);

  useEffect(() => {
    async function getData() {
      const result = await getUserWallet();
      if (result.status === 200) {
        const {user_wallet, wallet_changes, wallet_reservation_log, role_id} = result.data;
        setWallet(user_wallet)
        setWalletChanges(wallet_changes || [])
        setReserves(wallet_reservation_log || [])
        setRoleId(role_id);
      }
    }

    getData()
  }, [])

  useEffect(() => {
    setWalletBalance(wallet?.balance ?? 0)
    setWalletReservationBalance(wallet?.reservation_balance ?? 0)
    setWalletWithdrawalBalance(wallet?.withdrawal_balance ?? 0)
  }, [wallet])

  const bank_payment = async () => {
    const data = {
      amount: parseInt(depositValue),
      description: "wallet"
    };

    let result;
    result = await bankPayment(data)
    if (result.status === 200) {
      const {code, id} = result.data;
      localStorage.setItem("transaction_id", id)
      window.location.href = "https://api.payping.ir/v2/pay/gotoipg/" + code;
    }
  };

  const withdrawal = async () => {
    if (withdrawalValue > walletBalance) {
      Toaster.failure(null,
        <Typography variant="small">
          موجودی کافی نیست
        </Typography>);
      return

    }
    if (!withdrawalAccountId) {
      Toaster.failure(null,
        <Typography variant="small">
          حساب بانکی خود را انتخاب کنید
        </Typography>);
      return

    }
    const data = {
      value: parseInt(withdrawalValue),
      account_id: parseInt(withdrawalAccountId)
    };

    let result;
    result = await submitWalletWithdrawal(data)
    if (result.status === 200) {
      const {wallet} = result.data;
      setWallet(wallet)
    }
  };

  const downloadFile = async () => {
    try {

      const response = await axios.get(getBaseUrl() + `/person_wallet_change`, {
        responseType: 'blob', // Important to set responseType to 'blob' for file downloads
      });

      // Step 2: Handle the response as a Blob (binary data)
      const blob = response.data;

      // Step 3: Create a URL for the Blob object
      const downloadUrl = window.URL.createObjectURL(blob);

      // Step 4: Create an anchor element and trigger a download
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = 'wallet_changes.xlsx'; // Set default file name
      document.body.appendChild(link);
      link.click();

      // Clean up: remove the link element after download
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl); // Release the object URL

    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };


  return (
    <div className="flex flex-col w-full">

      <div className="flex flex-col w-full md:flex-row gap-8">

        <div className="flex flex-col w-full md:flex-col gap-y-8">

          <div className="flex flex-row">

            <Card className="w-full">
              <div className="flex flex-row align-baseline">
                <BsWallet2 className="mx-3" size="3em" color="blue-gray"/>
                <Typography variant="h5" className="mt-3" color="blue-gray">
                  کیف پول
                </Typography>
              </ div>
              <CardBody>
                <div className="flex flex-row gap-x-2 my-2 align-middle">
                  <Typography color="blue-gray">
                    موجودی:
                  </Typography>
                  <Typography color="blue-gray">
                    {persianNumberFormat(walletBalance, true) + " ریال"}
                  </Typography>
                </div>
                {walletReservationBalance > 0 &&
                  <div className="flex flex-row gap-x-2 my-2 align-middle">
                    <Typography color="blue-gray">
                      رزرو شده:
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(walletReservationBalance, true) + " ریال"}
                    </Typography>
                  </div>
                }
                {walletWithdrawalBalance > 0 &&
                  <div className="flex flex-row gap-x-2 my-2 align-middle">
                    <Typography color="blue-gray">
                      درخواست برداشت:
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(walletWithdrawalBalance, true) + " ریال"}
                    </Typography>
                  </div>
                }
              </CardBody>
            </Card>

          </div>

          <div className="flex flex-row">


            <Card className="w-full">
              <CardBody>
                <div className="mb-4 flex items-center justify-between">
                  <Typography variant="h5" color="blue-gray" className="">
                    رزروهای من
                  </Typography>
                  <Typography
                    as="a"
                    href="#"
                    variant="small"
                    color="blue"
                    className="font-bold"
                  >
                    همه
                  </Typography>
                </div>
                <div className="divide-y divide-gray-200">
                  {reserves &&
                    <WalletReservation reserves={reserves}/>
                  }
                </div>
              </CardBody>
            </Card>

          </div>

        </div>

        <div className="flex flex-col w-full md:flex-col gap-y-8">

          <div className="flex flex-row w-full">
            <Card className="w-full">
              <CardBody>
                <div className="flex flex-row align-baseline">
                  <BsDatabaseUp className="mx-3" size="2em"/>
                  <Typography variant="h5" className="mt-3" color="blue-gray">
                    شارژ حساب
                  </Typography>
                </ div>

                <div className="my-4">
                  <Input variant="standard"
                         label={Dict("deposit_number")}
                         placeholder={Dict("deposit_number")}
                         type={"number"}
                         value={depositValue}
                         step="10000"
                         onChange={(e) => {
                           setDepositValue(e.target.value)
                         }}
                  />
                  {depositValue > 0 &&
                    <Typography color="blue-gray" className="flex w-full my-4">
                      {"مبلغ شارژ کیف پول: " + persianNumberFormat(depositValue, true) + " ریال "}
                    </Typography>
                  }
                </div>
              </CardBody>
              <CardFooter className="textLeft">
                <Button variant="gradient" onClick={bank_payment}>
                  شارژ
                </Button>
              </CardFooter>

            </Card>
          </div>

          {roleId !== 3 &&
            <div className="flex flex-row w-full">
              <Card className="w-full">
                <CardBody>
                  <div className="flex flex-row align-baseline">
                    <BsDatabaseDown className="mx-3" size="2em"/>
                    <Typography variant="h5" className="mt-3" color="blue-gray">
                      برداشت از حساب
                    </Typography>
                  </ div>

                  <SelectInput
                    className="w-full my-4"
                    label={Dict("bank_accounts")}
                    defaultValue={withdrawalAccountId}
                    autoLoadService={getBankAccounts}
                    autoLoadRender={({title, card}) => {
                      return title + " - " + persianNumberFormat(card)
                    }}
                    onChange={setWithdrawalAccountId}
                  />

                  <div className="my-4">
                    <Input variant="standard"
                           label={Dict("withdrawal_number")}
                           placeholder={Dict("withdrawal_number")}
                           type={"number"}
                           value={withdrawalValue}
                           onChange={(e) => {
                             setWithdrawalValue(e.target.value)
                           }}
                    />
                    {withdrawalValue > 0 &&
                      <Typography color="blue-gray" className="flex w-full my-4">
                        {"مبلغ برداشت از کیف پول: " + persianNumberFormat(withdrawalValue, true) + " ریال "}
                      </Typography>
                    }
                  </div>
                </CardBody>
                <CardFooter className="textLeft">
                  <Button variant="gradient" onClick={withdrawal}>
                    برداشت
                  </Button>
                </CardFooter>

              </Card>
            </div>
          }
        </div>

      </div>

      <div className="flex flex-col mt-8 w-full md:flex-row">

        <div className="w-full">

          <Card className="max-w-full">
            <CardBody className="w-full overflow-x-scroll">
              <div className="flex flex-row max-w-full align-baseline justify-between">
                <div className="flex flex-row align-baseline">
                  <BsClockHistory className="flex flex-col mx-3" size="2em"/>
                  <Typography variant="h5" className="mt-3" color="blue-gray">
                    سابقه تراکنش‌ها
                  </Typography>
                </div>
                {walletChanges.length > 0 &&
                  <Button size="sm" variant="outlined" onClick={() => {
                    downloadFile("person_wallet_change", null, "wallet_changes")
                  }}>
                    خروجی اکسل
                  </Button>
                }
              </ div>
              <WalletChangesGrid walletChanges={walletChanges}/>
            </CardBody>

          </Card>

        </div>

      </div>

    </div>
  );
}